import { combineReducers } from "redux";
import { laudoReducer } from "./laudoReducer";
import { messageReducer } from "./messageReducer";
import { usuarioReducer } from "./usuarioReducer";

export const Reducers = combineReducers({
	messageState: messageReducer,
	laudoState: laudoReducer,
	usuarioLogadoState: usuarioReducer,
});
